import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ message = "Loading Znoospace..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <div className="znoospace-logo">
            🚀
          </div>
          <div className="loading-spinner">
            <div className="spinner-ring"></div>
          </div>
        </div>
        
        <div className="loading-message">
          {message}
        </div>
        
        <div className="loading-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
      
      {/* Cosmic background particles */}
      <div className="cosmic-background">
        <div className="star star-1">✨</div>
        <div className="star star-2">⭐</div>
        <div className="star star-3">🌟</div>
        <div className="star star-4">💫</div>
        <div className="star star-5">✨</div>
        <div className="star star-6">⭐</div>
      </div>
    </div>
  );
};

export default LoadingScreen;
